import { useLocation } from 'react-router';
import GlobalContext from './GlobalContext';
import API from '../api/api';
import { createContext, FC, useContext, useEffect, useState } from 'react';

export type TUnverifiedStaffAccountContext = {
    email: string;
    unverifiedStaffAccountUiState: EUnverifiedStaffAccountUiState;
    requestVerificationEmail: () => void;
    showToaster: boolean;
};

export enum EUnverifiedStaffAccountUiState {
    default,
    loading,
    error,
    success,
}

const UnverifiedStaffAccountContext = createContext<TUnverifiedStaffAccountContext | undefined>(undefined);

export const UnverifiedStaffAccountProvider: FC = ({ children }) => {
    const { gatewayAPIBaseUrl, customerAccountId, subscriberId } = useContext(GlobalContext);
    const [unverifiedStaffAccountUiState, setUnverifiedStaffAccountUiState] = useState(
        EUnverifiedStaffAccountUiState.default,
    );
    const [showToaster, setShowToaster] = useState(false);
    const { state: { email = '' } = {} } = useLocation<any>();

    const requestVerificationEmail = async () => {
        setUnverifiedStaffAccountUiState(EUnverifiedStaffAccountUiState.loading);
        const postObject = { email, customerAccountId, ...(subscriberId && { subscriberId }) };
        try {
            await API.post.requestVerifyStaff(gatewayAPIBaseUrl, postObject);
            setUnverifiedStaffAccountUiState(EUnverifiedStaffAccountUiState.success);
        } catch (error) {
            console.error('Failed to resend staff verification email');
            setUnverifiedStaffAccountUiState(EUnverifiedStaffAccountUiState.error);
        }
    };

    useEffect(() => {
        if (unverifiedStaffAccountUiState === EUnverifiedStaffAccountUiState.success) {
            setShowToaster(true);
            setTimeout(() => {
                setShowToaster(false);
            }, 5000);
        }
    }, [unverifiedStaffAccountUiState]);

    return (
        <UnverifiedStaffAccountContext.Provider
            value={{
                email,
                unverifiedStaffAccountUiState,
                requestVerificationEmail,
                showToaster,
            }}
        >
            {children}
        </UnverifiedStaffAccountContext.Provider>
    );
};

export default UnverifiedStaffAccountContext;
